export class DataModelGetSacAffecter {

    dateDebut: Date = new Date()
    dateFin: Date = new Date()

}